import { render, staticRenderFns } from "./TableCellTypeCheckbox.vue?vue&type=template&id=44525fcc&scoped=true"
import script from "./TableCellTypeCheckbox.vue?vue&type=script&lang=js"
export * from "./TableCellTypeCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44525fcc",
  null
  
)

export default component.exports